import {
  ALLOWED_GIF_MIME_TYPES,
  MAX_GIF_IMAGES,
  MAX_GIF_SOURCE_FILE_SIZE,
  MAX_SOURCE_DIMENSION,
  MIN_SOURCE_DIMENSION,
} from "./gifConstants";

const readImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    if (!file || file.size === 0) {
      reject(new Error("empty"));
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      URL.revokeObjectURL(objectUrl);
      resolve({ width, height });
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("corrupt"));
    };

    image.src = objectUrl;
  });

export const validateGifSourceFile = async (file) => {
  if (!file) {
    return { ok: false, reason: "empty", message: "The selected file could not be read." };
  }

  if (!file.size) {
    return {
      ok: false,
      reason: "empty",
      message: `${file.name || "This file"} is empty or corrupted.`,
    };
  }

  if (!ALLOWED_GIF_MIME_TYPES.includes(file.type)) {
    return {
      ok: false,
      reason: "type",
      message: `${file.name} is not a supported format. Please upload PNG, JPG or GIF images only.`,
    };
  }

  if (file.size > MAX_GIF_SOURCE_FILE_SIZE) {
    return {
      ok: false,
      reason: "size",
      message: `${file.name} exceeds the maximum allowed size of 2.5MB.`,
    };
  }

  try {
    const { width, height } = await readImageDimensions(file);

    if (!width || !height) {
      return {
        ok: false,
        reason: "corrupt",
        message: `${file.name} could not be read. Please choose another image.`,
      };
    }

    if (width < MIN_SOURCE_DIMENSION || height < MIN_SOURCE_DIMENSION) {
      return {
        ok: false,
        reason: "dimensions",
        message: `${file.name} is too small (${width}×${height}px). Minimum size is ${MIN_SOURCE_DIMENSION}×${MIN_SOURCE_DIMENSION}px.`,
      };
    }

    if (width > MAX_SOURCE_DIMENSION || height > MAX_SOURCE_DIMENSION) {
      return {
        ok: false,
        reason: "dimensions",
        message: `${file.name} is too large (${width}×${height}px). Maximum size is ${MAX_SOURCE_DIMENSION}×${MAX_SOURCE_DIMENSION}px.`,
      };
    }

    return { ok: true, width, height };
  } catch (error) {
    return {
      ok: false,
      reason: "corrupt",
      message: `${file.name || "This file"} is empty or corrupted.`,
    };
  }
};

export const getRemainingImageSlots = (currentCount) =>
  Math.max(0, MAX_GIF_IMAGES - (currentCount || 0));
